module.exports = __webpack_public_path__ + "img/security-audit-img-5.c3f13fa9.png";